import forEachSelector from 'mex_components/app/scripts/elements/forEachSelector';
import addTargetEventListener from 'mex_components/app/scripts/events/addTargetEventListener';

const DROPDOWN_BUTTON = '.tutor-dropdown__button';
const DROPDOWN_CONTENT = '.tutor-dropdown__content';
const ACCORDION_BUTTON = '.dropdown-accordion__header';
const ACCORDION_CONTENT = '.dropdown-accordion__content';

const isExpanded = (el) => el.getAttribute('aria-expanded') === 'true';
const addExpanded = (el) => el.setAttribute('aria-expanded', 'true');
const removeExpanded = (el) => el.removeAttribute('aria-expanded');

const closeDropdowns = () =>
  forEachSelector([DROPDOWN_BUTTON, DROPDOWN_CONTENT].join(', '), removeExpanded);

const closeAccordions = () =>
  forEachSelector([ACCORDION_BUTTON, ACCORDION_CONTENT].join(', '), removeExpanded);

export function handleClickAnywhere(event) {
  if(event.target && !event.target.closest('.tutor-dropdowns')) {
    closeDropdowns();
  }
}

export function handleClickDropdown(event) {
  event.preventDefault();
  const targetIsOpen = isExpanded(this);
  closeDropdowns();

  if(!targetIsOpen) {
    addExpanded(this);
    this.parentNode.querySelector(DROPDOWN_CONTENT).setAttribute('aria-expanded', 'true');
  }
}

export function handleClickAccordion(event) {
  event.preventDefault();
  const targetIsOpen = isExpanded(this);
  closeAccordions();

  if(!targetIsOpen) {
    addExpanded(this);
    this.parentNode.parentNode.querySelector(ACCORDION_CONTENT)
      .setAttribute('aria-expanded', 'true');
  }
}

document.addEventListener('click', handleClickAnywhere);
addTargetEventListener('click', DROPDOWN_BUTTON, handleClickDropdown);
addTargetEventListener('click', ACCORDION_BUTTON, handleClickAccordion);
